import { styled } from '../../../../Styles/stitches.config'

export const Rating = styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '$3',

    '@desktop': {
        alignItems: 'end',
        borderBottom: '1px solid $neutral300',
        pb: '$2',
    },

    '@mobile': {
        flexDirection: 'column',
    },
})
